import {
  MDBFooter,
  MDBContainer,
  MDBCol,
  MDBRow,
} from 'mdb-react-ui-kit';

import facebook from '../../images/social-media-icons/icons8-facebook-24.png';
import whatsApp from '../../images/social-media-icons/icons8-whatsapp-24.png';
import instagram from '../../images/social-media-icons/icons8-instagram-24.png';
import twitter from '../../images/social-media-icons/icons8-twitter-24.png';
import youtube from '../../images/social-media-icons/icons8-youtube-24.png';

import { useAuth } from '../../authUtils';
import { signOut } from 'firebase/auth';
import { database } from '../../config';
import {useNavigate} from "react-router-dom";

function Footer() {
  const loggedIn = useAuth();
  const history = useNavigate();
  const logout = ()=>{
    signOut(database).then(data=>{
      history('/admin/login')
    })
  }
  return (
    <MDBFooter bgColor='dark' className='text-white'>
      <MDBContainer className='p-4'>
        <MDBRow>
          <MDBCol lg="6" md="12" className='mb-4 mb-md-0'>
            <h5 className='text-uppercase'>Holla's Trekking</h5><br/>
            <ul className='list-unstyled'>
              <li><a href='tel:9535XXXXXX' className='text-white footer-text'>PHONE : 9535XXXXXX</a></li>
              <li><a href='mailto:sudheshholla15@gmail.com' className='text-white footer-text'>EMAIL: contact@hollastrekking.in</a></li>
              <li><a href='https://maps.app.goo.gl/mxCrCJebyBrv5gKL6' target='_blank' className='text-white footer-text'>OFFICE: Indiranagara, Bengaluru - 560038</a></li>
            </ul>
            <br/>
            <div style={{ display: 'flex', gap: '15px' }}>
              <img src={facebook}/>
              <img src={instagram}/>
              <img src={whatsApp}/>
              <img src={twitter}/>
              <img src={youtube}/>
            </div>
          </MDBCol>

          <MDBCol lg="3" md="6" className='mb-4 mb-md-0'>
            <h5 className='text-uppercase mb-0'>&nbsp;ADMIN Links</h5><br/>

            <ul className='list-unstyled'>
            {loggedIn ? (
              <>
                <li><a onClick={logout} className="fontColor-4">LOGOUT</a></li>
                <li><a href='/admin/dashboard' className='text-white footer-text'>&nbsp;DASHBOARD</a></li>
                <li><a href='/admin/addNewTrek' className='text-white footer-text'>&nbsp;ADD TREK</a></li>
              </>
            ) : (
                <li><a href='/admin/login' className='text-white footer-text'>&nbsp;LOGIN</a></li>
            )}
              
              
            </ul>
          </MDBCol>

          <MDBCol lg="3" md="6" className='mb-4 mb-md-0'>
            <h5 className='text-uppercase mb-0'>Important Links</h5><br/>

            <ul className='list-unstyled'>
              <li><a href='/home' className='text-white footer-text'>HOME</a></li>
              <li><a href='/about' className='text-white footer-text'>ABOUT</a></li>
              <li><a href='/displayAllTreks' className='text-white footer-text'>TREKS</a></li>
              <li><a href='/gallery' className='text-white footer-text'>GALLERY</a></li>
              <li><a href='/contact' className='text-white footer-text'>CONTACT</a></li>
              <li><a href='/release-notes' className='text-white footer-text'>RELEASE NOTES</a></li>
            </ul>
          </MDBCol>
        </MDBRow>
      </MDBContainer>

      <div className='text-center p-3' style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
        Designed & Developed by <a href='https://www.sudheshholla.in/' target="_blank" className="lastFooter">Sudhesh Holla</a>
      </div>
    </MDBFooter>
  )
}

export default Footer